import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComment = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.1875 17.625C8.71875 17.625 8.32031 17.4609 7.99219 17.1328C7.66406 16.8047 7.5 16.4062 7.5 15.9375V14.8125H18.1875V7.5H19.3125C19.7812 7.5 20.1797 7.66406 20.5078 7.99219C20.8359 8.32031 21 8.71875 21 9.1875V21L17.625 17.625H9.1875ZM3 16.5V4.6875C3 4.21875 3.16406 3.82031 3.49219 3.49219C3.82031 3.16406 4.21875 3 4.6875 3H14.8125C15.2812 3 15.6797 3.16406 16.0078 3.49219C16.3359 3.82031 16.5 4.21875 16.5 4.6875V11.4375C16.5 11.9062 16.3359 12.3047 16.0078 12.6328C15.6797 12.9609 15.2812 13.125 14.8125 13.125H6.375L3 16.5Z",
		fill: "currentColor"
	})
});
export default SvgComment;
